<template>
    <div>
        <v-hover
            v-slot="{ hover }"
        >
            <v-card 
                :elevation="hover ? 6 : 1"
                class="mx-auto mb-4" 
                variant="outlined" 
                style="background-color: white;"
            >
                <div class="d-flex justify-space-between align-start pa-4 pb-2">
                    <div class="text-subtitle-1 font-weight-bold text-truncate">
                        {{ item.name }}
                    </div>
                </div>

                <v-divider class="mx-4 my-0"></v-divider>

                <v-card-text class="py-1 px-4">
                    <div class="d-flex align-center text-body-2 text-medium-emphasis font-weight-bold">
                        {{ item.profile }}
                    </div>
                </v-card-text>

                <v-card-text class="py-1 px-4">
                    <div class="d-flex align-center text-body-2 text-medium-emphasis">
                        {{ item.email }}
                    </div>
                    <div class="d-flex align-center text-body-2 text-medium-emphasis">
                        <span v-if="item.telefone1">{{ item.telefone1 }}</span>
                        <span v-if="item.telefone2" class="m-2">{{ item.telefone2 }}</span>
                    </div>
                </v-card-text>

            
                <v-card-actions class="d-flex pa-4 bg-grey-lighten-5 justify-end">
                    <v-btn
                        class="ml-4"
                        @click.prevent="editItem(item.id)"
                        fab
                        small
                    >
                        <v-icon color="primary">
                            mdi-pencil
                        </v-icon>
                    </v-btn>

                    <v-btn
                        v-if="me.profile == 'Master'"
                        class="ml-4"
                        @click.prevent="confirmDestroy(item)"
                        fab
                        small
                    >
                        <v-icon color="error">
                            mdi-delete
                        </v-icon>
                    </v-btn>
                </v-card-actions>
                
                
            </v-card>
        </v-hover>    
    </div>
</template>

<script>
export default {
    name: 'MobileReportCard',

    props: {
        item: {
            type: Object,
            required: true
        }
    },

    computed: {
        me () {
          return this.$store.state.auth.me
        },
    }, 

    methods: {
        editItem(id){
            this.$emit('callEditItem', id)
        },

        confirmDestroy(item){
            this.$emit('callConfirmDestroy', item)
        },
    }
}   
</script>